export default __webpack_public_path__ + "static/media/AI.476939fd.png";